import { getToday } from '../../../../../api/pleri-usage';
import { getConversationSourceLabel } from '../../../constants';
import type { TFunction } from 'i18next';
import { formatLocale } from '@plerionhq/design-system';

export const formatNumber = (num: number) =>
  new Intl.NumberFormat(formatLocale()).format(num);

export const formatShortDate = (dateStr: string) =>
  new Date(dateStr).toLocaleDateString(formatLocale(), {
    month: 'short',
    day: 'numeric',
  });

export function allDaysInRange(start: string, end: string): string[] {
  const out: string[] = [];
  const d = new Date(start);
  const endD = new Date(end);
  while (d <= endD) {
    const y = d.getFullYear();
    const m = String(d.getMonth() + 1).padStart(2, '0');
    const day = String(d.getDate()).padStart(2, '0');
    out.push(`${y}-${m}-${day}`);
    d.setDate(d.getDate() + 1);
  }
  return out;
}

export function getPeriodForMonth(
  year: number,
  month: number,
): { start: string; end: string } {
  const y = year;
  const m = String(month).padStart(2, '0');
  const start = `${y}-${m}-01`;
  const today = new Date();
  const isCurrentMonth =
    today.getFullYear() === year && today.getMonth() + 1 === month;
  const end = isCurrentMonth
    ? getToday()
    : (() => {
        const lastDay = new Date(year, month, 0);
        const dy = lastDay.getFullYear();
        const dm = String(lastDay.getMonth() + 1).padStart(2, '0');
        const dd = String(lastDay.getDate()).padStart(2, '0');
        return `${dy}-${dm}-${dd}`;
      })();
  return { start, end };
}

export function getMonthOptions(): Array<{ value: string; label: string }> {
  const options: Array<{ value: string; label: string }> = [];
  const now = new Date();
  for (let i = 0; i < 12; i++) {
    const d = new Date(now.getFullYear(), now.getMonth() - i, 1);
    const year = d.getFullYear();
    const month = d.getMonth() + 1;
    const value = `${year}-${String(month).padStart(2, '0')}`;
    const label = d.toLocaleDateString(formatLocale(), {
      month: 'short',
      year: 'numeric',
    });
    options.push({ value, label });
  }
  return options;
}

export const MONTH_OPTIONS = getMonthOptions();

export function getIdentityTypeLabel(t: TFunction<'pleri/settings'>, raw: string | null | undefined): string {
  if (!raw) {
    return t('unknown');
  }
  const v = raw.toLowerCase();
  if (v === 'user' || v === 'human') {
    return t('humanUser');
  }
  if (v === 'system') {
    return t('system');
  }
  if (v === 'agent' || v === 'service') {
    return t('agentService');
  }
  return raw.charAt(0).toUpperCase() + raw.slice(1);
}

export function getWorkspaceLabel(t: TFunction<'pleri/settings'>, raw: string): string {
  return getConversationSourceLabel(t, raw);
}
